import React, { useEffect } from "react";
import "./App.css";
import Navbar from "./component/common/Navbar";
import { Route, Routes } from "react-router-dom";
import { apiConnector } from "./Services/ApiConnector";
import { healthEndPoint } from "./Services/AllApi";
import Homepage from "./Pages/Homepage";
//import MyProfile from "./component/core/Dashboard/Profile/MyProfile";
//import Dashboard from "./Pages/Dashboard";
//import Setting from "./component/core/Dashboard/Settings/Setting";
//import EnrolledUser from "./component/core/Dashboard/EnrolledUser/EnrolledUser";
//import { PrivateRoute } from "./PrivateRoute";
//import CreateLibrary from "./component/core/Dashboard/Library/CreateLibrary";
import LibraryDetailsByName from "./component/core/LibrarySection/LibraryDetailsByName";
import LibraryDetailById from "./component/core/LibrarySection/LibraryDetailById";
//import AllLibraryContent from "./component/core/Dashboard/LibraryContent/AllLibraryContent";
import Songs from "./Pages/Songs";
import SongsByType from "./Pages/SongsByType";
//import CreateSection from "./component/core/Dashboard/Section/CreateSection";
//import CreateReview from "./component/core/Dashboard/Review/CreateReview";
import TemplePage from "./Pages/TemplePage";
//import CreatePrivateCoupon from "./component/core/Dashboard/Coupon/CreateCoupon";
//import AllCoupon from "./component/core/Dashboard/Coupon/AllCoupon";
//import CreateTempleLoc from "./component/core/Dashboard/TempleLoc/CreateTempleLoc";
//import CreateTempleDetails from "./component/core/Dashboard/TempleDetail/CreateTempleDetails";
import TempleById from "./component/core/TempleSection/TempleById";
import KashiVishwanath from "./Pages/TempleDetail/KashiVishwanath";
import JagannathPuri from "./Pages/TempleDetail/JagannathPuri";
import VaishnoDevi from "./Pages/TempleDetail/VaishnoDevi";
import HarKiPauri from "./Pages/TempleDetail/HarKiPauri";
import Lokhnath from "./Pages/TempleDetail/Lokhnath";
import Kamakhya from "./Pages/TempleDetail/Kamakhya";
import Tirupati from "./Pages/TempleDetail/Tirupati";
import GoldenTemple from "./Pages/TempleDetail/GoldenTemple";
import Somnath from "./Pages/TempleDetail/Somnath";
import Meenakshi from "./Pages/TempleDetail/Meenakshi";
import Astrology from "./Pages/Astrology";
//import GetAstrologyUser from "./component/core/Dashboard/Astrology/GetAstrologyUser";
import ForgotPassword from "./Pages/ForgotPassword";
import UpdateForgotPassword from "./Pages/UpdateForgotPassword";
import ContactUs from "./Pages/ContactUs";
import Live from "./Pages/Live";
import Auth from "./Pages/Auth";
import Profile from "./Pages/Profile";

import VideoDetail from "./Pages/VideoDetail";
import Panchang from "./Pages/Panchang";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AudioProvider } from "./contexts/AudioContext";
import AuthNotification from "./component/common/AuthNotification";
import ScrollToTop from "./component/common/ScrollToTop";


const App = () => {
  // Health check function
  const checkHealth = async () => {
    try {
      console.log('🔍 Checking backend health...');
      //console.log('🌐 Endpoint:', healthEndPoint.HEALTH_CHECK_API);
       await apiConnector('GET', healthEndPoint.HEALTH_CHECK_API);
      //console.log('✅ Backend Health Check Response:', response);
      //console.log('📊 Health Status:', response.data);
      console.log('🎉 Backend is healthy and ready!');
    } catch (error) {
      console.error('❌ Backend Health Check Failed');
      console.warn('⚠️ Backend might be down or experiencing issues');
    }
  };

  // Run health check on component mount (initial load and refresh)
  useEffect(() => {
    checkHealth();
  }, []);

  return (
    <LanguageProvider>
      <AudioProvider>
        <div>
          <ScrollToTop />
          <Navbar />
          <div className="lg:pb-0 pb-16">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/articles/:sectionName" element={<LibraryDetailsByName />} />
          <Route path="/articles/:sectionName/:subsectionId" element={<LibraryDetailById />} />
          <Route path="/songs" element={<Songs />} />
          <Route path="/songs/:sectionName" element={<SongsByType />} />
          <Route path="/songs/:sectionName/:subsectionId" element={<LibraryDetailById />} />
          <Route path="/temples" element={<TemplePage />} />
          <Route path="/temples/kashi" element={<KashiVishwanath />} />
          <Route path="/temples/jagannath" element={<JagannathPuri />} />
          <Route path="/temples/vaishno-devi" element={<VaishnoDevi />} />
          <Route path="/temples/haridwar" element={<HarKiPauri />} />
          <Route path="/temples/lokhnath" element={<Lokhnath />} />
          <Route path="/temples/kamakhya" element={<Kamakhya />} />
          <Route path="/temples/tirupati" element={<Tirupati />} />
          <Route path="/temples/golden-temple" element={<GoldenTemple />} />
          <Route path="/temples/somnath" element={<Somnath />} />
          <Route path="/temples/meenakshi" element={<Meenakshi />} />
          <Route path="/temples/:templeId" element={<TempleById />} />
          <Route path="/astrology" element={<Astrology />} />
          <Route path="/update-password" element={<ForgotPassword />} />
          <Route path="/update-password/:token" element={<UpdateForgotPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/live" element={<Live />} />
          <Route path="/live/:videoId" element={<VideoDetail />} />
          <Route path="/panchang" element={<Panchang />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/profile" element={<Profile />} />

        {/* <Route path="/dashboard" element={<Dashboard />}>
          <Route path="/dashboard/my-profile" element={<PrivateRoute><MyProfile /></PrivateRoute>} />

          <Route path="/dashboard/settings" element={<PrivateRoute><Setting /></PrivateRoute>} />
          <Route path="/dashboard/Enrolled-user" element={<PrivateRoute><EnrolledUser /></PrivateRoute>} />
          <Route path="/dashboard/create-library" element={<PrivateRoute><CreateLibrary /></PrivateRoute>} />
          <Route path="/dashboard/library-content" element={<PrivateRoute><AllLibraryContent /></PrivateRoute>} />
          <Route path="/dashboard/create-section" element={<PrivateRoute><CreateSection /></PrivateRoute>} />
          <Route path="/dashboard/create-review" element={<PrivateRoute><CreateReview /></PrivateRoute>} />
          <Route path="/dashboard/create-Coupon" element={<PrivateRoute><CreatePrivateCoupon /></PrivateRoute>} />
          <Route path="/dashboard/all-Coupon" element={<PrivateRoute><AllCoupon /></PrivateRoute>} />
          <Route path="/dashboard/temple-loc" element={<PrivateRoute><CreateTempleLoc /></PrivateRoute>} />
          <Route path="/dashboard/temple-detail" element={<PrivateRoute><CreateTempleDetails /></PrivateRoute>} />
          <Route path="/dashboard/astrology-user" element={<PrivateRoute><GetAstrologyUser /></PrivateRoute>} />
        </Route> */}
      </Routes>
    </div>
        
        {/* Auth Notification */}
        <AuthNotification />
        </div>
      </AudioProvider>
    </LanguageProvider>
  );
};

export default App;
